import Api from "../../axios"

export const getInOutMissingEntry = async ({id, date})=>{
    return await Api.get(`/missing_view?date=${date}&employee_id=${id}`)
}